/*
 * FROSTBEULE · Gift idea (owner: PAGES) – <fb-gift-unwrap>.
 * Markup ships unpacked (.is-open) so it reads fine without JS. With motion != none the package is packed
 * on connect, wiggles while visible and unpacks itself once 55 % of it is on screen. The button
 * (label swaps) packs/unpacks again; the stage is a mouse/touch shortcut for the same action.
 * Status changes go to a polite live region. Survives shopify:section:load/unload.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('fb-gift-unwrap')) return;

  var html = document.documentElement;
  var motion = function () {
    var C = window.FROSTBEULE;
    if (C && typeof C.motion === 'function') return C.motion();
    return html.getAttribute('data-motion') || 'full';
  };

  class FbGiftUnwrap extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-gift-toggle]');
      this.label = this.querySelector('[data-gift-label]');
      this.live = this.querySelector('[data-gift-live]');
      this.stage = this.querySelector('[data-gift-stage]');
      this.timer = 0;

      if (this.btn) {
        this.btn.hidden = false;
        this.onClick = this.toggle.bind(this);
        this.btn.addEventListener('click', this.onClick);
      }

      if (motion() === 'none' || !('IntersectionObserver' in window)) {
        this.sync(true);
        return;
      }

      this.classList.add('is-armed');
      this.setOpen(false, false);

      if (this.stage) {
        this.onStage = function (e) {
          /* the 3D box has its own drag/tilt – clicks on it must not pack the gift again */
          if (e.target.closest && e.target.closest('.fb-gift__reveal')) return;
          this.toggle();
        }.bind(this);
        this.stage.addEventListener('click', this.onStage);
      }

      this.autoDone = false;
      this.io = new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (e) {
              this.classList.toggle('is-visible', e.isIntersecting);
              if (e.isIntersecting && e.intersectionRatio >= 0.55 && !this.autoDone) {
                this.autoDone = true;
                this.timer = setTimeout(
                  function () {
                    if (!this.classList.contains('is-open')) this.setOpen(true, false);
                  }.bind(this),
                  450
                );
              }
            }.bind(this)
          );
        }.bind(this),
        { threshold: [0, 0.55] }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      clearTimeout(this.timer);
      if (this.btn && this.onClick) this.btn.removeEventListener('click', this.onClick);
      if (this.stage && this.onStage) this.stage.removeEventListener('click', this.onStage);
    }

    toggle() {
      this.autoDone = true;
      clearTimeout(this.timer);
      this.setOpen(!this.classList.contains('is-open'), true);
    }

    setOpen(open, announce) {
      this.classList.toggle('is-open', open);
      if (open && motion() !== 'none') {
        this.classList.remove('is-burst');
        void this.offsetWidth;
        this.classList.add('is-burst');
      } else {
        this.classList.remove('is-burst');
      }
      this.sync(open);
      if (announce && this.live) {
        this.live.textContent = this.getAttribute(open ? 'data-live-open' : 'data-live-close') || '';
      }
    }

    sync(open) {
      if (!this.btn) return;
      if (this.label) {
        this.label.textContent = this.getAttribute(open ? 'data-label-close' : 'data-label-open') || '';
      }
    }
  }

  customElements.define('fb-gift-unwrap', FbGiftUnwrap);
})();
